var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 340,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#facc15",
    d: "M292.3529198849611,302.3529198849611C275.2323941877139,314.77984507975856,236.9772882807563,295.03523618301546,210,294.5615511687847C183.0227117192437,294.087866154554,154.1494064694599,311.93773499437424,130.48919020042322,299.5108097995768C106.82897393138654,287.08388460477937,67.78836306506862,246.2532639458143,68.03870238577994,220.00000000000003C68.28904170649126,193.74673605418576,108.3310098556545,167.12638596389945,131.99122612469117,141.9912261246912C155.65144239372785,116.85606628548294,185.86408858649767,67.32202775314988,209.99999999999997,69.18904096475052C234.13591141350227,71.05605417635115,259.6861689084578,128.05814555508675,276.806694605705,153.193305394295C293.9272203029522,178.32846523350327,310.13211663694045,195.14006425155566,312.72315418348313,220C315.3141917300258,244.85993574844434,309.47344558220834,289.9259946901637,292.3529198849611,302.3529198849611",
    stroke: "none",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.42f79961047399ed2a78d7018886fd3d.svg";
export { ForwardRef as ReactComponent };